import { MatDateFormats } from '@angular/material';

export const AzcDateFormat: MatDateFormats = {
	parse: {
		dateInput: 'DD/MM/YYYY',
	},
	display: {
		dateInput: 'D MMM YYYY',
		monthYearLabel: 'MMM YYYY',
		dateA11yLabel: 'D MMM YYYY',
		monthYearA11yLabel: 'MMMM YYYY',
	},
};
